var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nav-list-item",style:(_vm.checkStyle),on:{"click":_vm.check}},[_c('span',[(_vm.back)?_c('span',[_vm._v("< ")]):_vm._e(),_vm._v(_vm._s(_vm.item.name))]),(!_vm.back)?_c('span',{staticStyle:{"color":"#888"}},[_vm._v(">")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }